export default "__VITE_ASSET__d070e42f__"